import { NotificationForm } from '../../../../../../notificationForms/sections/notifications/components/NotificationForm'
import { NotificationView } from '../../../../../../notificationForms/sections/notifications/components/NotificationView'

import { CompletedNotificationView } from './components/CompletedNotificationView'

import { useFormStateController } from '../../hooks/useFormStateController'
import { useCompletedNotificationSubmit } from './hooks/useCompletedNotificationSubmit'
import { useCompletedNotificationToggle } from './hooks/useCompletedNotificationToggle'
import { useCompletedNotificationValues } from './hooks/useCompletedNotificationValues'

import type { FormProps } from '../types'
import { useTexts } from './useTexts'

/**
 * Renders the Completed notification form providing all the domain data and apis.
 */
export function CompletedNotification(props: FormProps) {
  const { inEditing, setEditingState } = props

  const values = useCompletedNotificationValues()

  const { toggleDescription, onToggle } = useCompletedNotificationToggle(values)
  const { edit, cancel } = useFormStateController(setEditingState)
  const onSubmit = useCompletedNotificationSubmit()
  const texts = useTexts()

  // Render the Form inside a FormRoot component that will expose the FormState API through a React.Context
  if (inEditing) {
    return (
      <NotificationForm
        subtitle={texts.description}
        notification="completed"
        onSubmit={onSubmit}
        title={texts.title}
        cancel={cancel}
        values={values}
      />
    )
  }

  return (
    <NotificationView
      Form={<CompletedNotificationView values={values} />}
      toggleSubtitle={toggleDescription}
      subtitle={texts.description}
      notification="completed"
      onToggle={onToggle}
      title={texts.title}
      values={values}
      onEdit={edit}
      available
    />
  )
}
